export class Ledger {
    id?: number;
    bank_name: string;
    currency: string;

    entries: LedgerEntry[] = [];
}

export class LedgerEntry {
    id: number;
    transaction: number = 0;
    date: string;
    last_updated: string;
    description: string;
    in: number;
    out: number;
    vat: number;
    balance: number;
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/ledger.ts